export default __webpack_public_path__ + "static/media/icon_intelligence_visual.404a18cd.svg";